/**
 * @ngdoc Filter
 * @name vrmDeviceIcon
 */

(function () {
    'use strict';

    angular.module('vrm.components')
        .filter('vrmHourFormat', vrmHourFormat);

    /* @ngInject */
    function vrmHourFormat(locale) {
        return function (hours) {
            var rhours = Math.floor(hours);
            var minutes = (hours - rhours) * 3600 / 60;
            var rminutes = Math.round(minutes);
            return rhours.toString().padStart(2, "0") +":"+rminutes.toString().padStart(2, "0");
        };
    }

})();
